import { ThemeOptions } from '@mui/material/styles';

export const acaColors = {
  primary: '#034f9d',
  primaryShade: '#03468a',
  primaryTint: '#1c61a7',
  primaryContrast: '#ffffff',
  backgroundContent: '#f5f6f7',
} as const;

const acaThemeOptions: ThemeOptions = {
  palette: {
    primary: {
      main: acaColors.primary,
      dark: acaColors.primaryShade,
      light: acaColors.primaryTint,
      contrastText: acaColors.primaryContrast,
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: `${acaColors.primary} !important`,
          color: acaColors.primaryContrast,
          '& .MuiIconButton-root': {
            color: acaColors.primaryContrast,
          },
          '& svg path': {
            fill: acaColors.primaryContrast,
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          borderRadius: '16px',
          overflow: 'hidden',
          position: 'relative' as const,
          paddingBottom: '4px',
          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: '4px',
            background:
              'linear-gradient(to right, #e31b23, #a11a5e, #5b2d8e, #1b3fa0, #0a2f9a)',
          },
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: acaColors.primary,
          '&:focus': {
            color: acaColors.primaryShade,
            outline: `solid 2px ${acaColors.primaryShade}`,
          },
          '&:hover': {
            color: acaColors.primaryShade,
          },
        },
      },
    },
    MuiButton: {
      variants: [
        {
          props: { variant: 'contained' },
          style: {
            backgroundColor: acaColors.primary,
            '&:focus': {
              border: `1px solid ${acaColors.primaryShade}`,
              backgroundColor: acaColors.primaryShade,
              outline: `solid 2px ${acaColors.primaryShade}`,
              outlineOffset: '1px',
            },
            '&:hover': {
              backgroundColor: acaColors.primaryShade,
            },
          },
        },
        {
          props: { variant: 'text' },
          style: {
            '&:focus': {
              color: acaColors.primaryShade,
              outline: `solid 2px ${acaColors.primaryShade}`,
              outlineOffset: '1px',
            },
          },
        },
      ],
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          '.MuiSwitch-switchBase.Mui-checked:hover': {
            backgroundColor: `${acaColors.primary}1A`,
          },
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&:focus': {
            outline: `solid 2px ${acaColors.primaryShade}`,
          },
        },
      },
    },
  },
};

export default acaThemeOptions;
